import { kitAssemblyCRUDApi, kitAssemblyViewApi, kitDropdownApi, kitInventoryCreateApi, kitInventoryCRUDApi, kitInventoryViewApi, rawInventoryDropdownApi, rawMaterialInventoryCRUDApi, rawMaterialInventoryCRUDTransactionApi, rawMaterialInventoryDetailedViewApi, rawMaterialInventoryViewApi } from "../constants/apis";
import axios from "axios";
import { getUserToken } from "../helpers/local_storage_helpers";

export const getRawMaterialInventoryView = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(rawMaterialInventoryViewApi + `${query || ""}`, config);

    return response;
};

export const getRawMaterialInventoryDetailedView = async (id) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(rawMaterialInventoryDetailedViewApi + id, config);

    return response;
};

export const postRawMaterialInventory = async (data) => {
    const config = {
        headers: {
            // "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.post(rawMaterialInventoryCRUDApi, data, config);
    return response;
};

export const postRawMaterialInventoryTransaction = async (data) => {
    const config = {
        headers: {
            // "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.post(rawMaterialInventoryCRUDTransactionApi, data, config);
    return response;
};

export const getKitInventoryView = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(kitInventoryViewApi + `${query || ""}`, config);

    return response;
};

export const getKitAssemblyView = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(kitAssemblyViewApi + `${query || ""}`, config);

    return response;
};

export const getRawInventoryDropdown = async () => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(rawInventoryDropdownApi, config);

    return response;
};

export const getKitDropdown = async () => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(kitDropdownApi, config);

    return response;
};

export const postKitInventoryView = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.post(kitInventoryCreateApi, data, config);

    return response;
};

export const postKitAssemblyView = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.post(kitAssemblyCRUDApi, data, config);

    return response;
};

export const postKitInventoryCrud = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.post(kitInventoryCRUDApi, data, config);

    return response;
};

export const patchKitInventoryView = async (id, data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.patch(kitInventoryCRUDApi + id + "/", data, config);

    return response;
};